import React, { useContext, useEffect } from 'react';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { ClassroomContext } from '../../context/ClassroomContext';
import ClassroomTabs from './ClassroomTabs';
import ClassroomAnnouncements from './ClassroomAnnouncements';
import Folders from './Folders';
import Folder from './Folder';
import People from './People';
import ClassroomSettings from './ClassroomSettings';
import ClassroomAbout from './ClassroomAbout';
import styles from './styles/Classroom.module.css';
import AuthContext from '../../context/AuthContext';
import ClassroomDashboard from './ClassroomDashboard';
import Loading from '../loading/Loading';
import ClassroomAssignments from './ClassroomAssignments';
import ClassroomAssignmentSubmissions from './ClassroomAssignmentSubmissions';
import ClassroomGrades from './ClassroomGrades';
import ClassroomTeacherGrades from './ClassroomTeacherGrades';
import ClassroomFeedback from './ClassroomFeedback';

const Classroom = () => {
    const { 
        classroom, 
        isMember,
        isTeacher,
        fetchClassroom,
        isFetchingClassroomDetails,
    } = useContext(ClassroomContext);

    const { classroomId } = useParams();
    const { userId } = useContext(AuthContext);
    const navigate = useNavigate(); 

    useEffect(() => {
        if (classroomId && userId) {
            fetchClassroom(classroomId, userId);
        }
    }, [classroomId, userId, fetchClassroom]); 

    
    useEffect(() => {
        if (isFetchingClassroomDetails) return;
        if (!userId) {
            navigate('/');
            return;
        }

        if (isMember === false) {
            navigate('/home');
        }
    }, [isFetchingClassroomDetails, isMember, userId, navigate]);
    
    if (isFetchingClassroomDetails || isMember === null) { 
        return <div className={styles.centeredContainer}><Loading /></div>;
    }

    return (
        <div className={styles.classroomContainer}>
            {classroom && (
                <>
                    <Routes>
                        <Route path="/a" element={<ClassroomAnnouncements />} />
                        <Route path="/d" element={<ClassroomDashboard />} />
                        <Route path="/feedback" element={<ClassroomFeedback />} />
                        <Route path="/f" element={<Folders/>} />
                        <Route path="/f/:folderId" element={<Folder />} />
                        <Route path="/assignments" element={<ClassroomAssignments />} />
                        <Route path="/assignments/:assignmentId" element={<ClassroomAssignmentSubmissions />} />
                        <Route path="/p" element={<People />} />
                        <Route path="/i" element={<ClassroomAbout />} />
                        <Route path="/settings" element={<ClassroomSettings />} />
                        <Route path="/gs" element={<ClassroomGrades />} />
                        <Route path="/gt" element={<ClassroomTeacherGrades isTeacher={isTeacher}/>} />
                    </Routes>
                </>
            )}
        </div>
    );
};

export default Classroom;
